if (process.env.REACT_APP_SITE_CODE === 'spring') {
  module.exports = require('./type.spring')
} else if (process.env.REACT_APP_SITE_CODE === 'lsav') {
  module.exports = require('./type.lsav')
} else {
  module.exports = require('./type.shy')
}
